/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "iPhone XS Max",
    img: "/assets/iphone-front.png",
    price: 1200,
    company: "Apple",
    info:
      "A Super Retina OLED display. Even faster Face ID. And a breakthrough dual-camera system. The iPhone XS is everything you love about iPhone. Taken to the extreme. Apple finally delivers an iPhone with a huge screen, and for movie-watching, game-playing fans the iPhone XS Max is an exciting new addition to the range. It certainly costs a lot, but if you can get past the price (which many won't be able to) the XS Max offers up a super, supersized experience.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Google Pixel 3+",
    img: "/assets/pixel-3-front.png",
    price: 600,
    company: "Google",
    info:
      "The Google Pixel 3 XL is the best big-screened camera phone you can buy today, one that’s able to capture stunning photos that your friends won’t believe came from a smartphone. You’ll have to be okay with its prominent at the top of the 6.3-inch display and the higher price, a familiar trade-offs for a little extra screen space in 2019. It’s battery life is bigger, too, and the main reason to choose this phone over the otherwise similar 5.5-inch Google Pixel 3.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Samsung Galaxy s10+",
    img: "/assets/samsung-s10-front.png",
    price: 1099,
    company: "Samsung",
    info:
      "Completely redesigned to remove interruptions from your view. The Galaxy S10+ introduces a stunning new Infinity-O Display. It’s crafted from flawless glass which wraps perfectly from edge to edge. It’s minimal, beautiful and effortlessly elegant. With no home button, no notch for the receiver and a simple dot opening for the front camera, you’ll have an uninterrupted viewing experience.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Samsung Galaxy Note10+",
    img: "/assets/note10-plus-front.jpg",
    price: 1200,
    company: "Samsung",
    info:
      "The Galaxy Note 10 Plus is Samsung's biggest and most powerful phone yet, and its Aura colors almost symbolically reflect smartphone luxury top to bottom. The hand-stretching 6.8-inch display is perfectly paired with the S Pen and an extra-big battery. Sure, it's technically neither the fastest nor the best camera phone, but it's the most fun we've had testing a phone in 2019 thanks to its five cameras and smart photo filters. This is one to get if you want to bask in pre-foldable phone opulence.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "Huawei P30 Pro",
    img: "/assets/p30-pro-front.jpg",
    price: 1099,
    company: "Huawei",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "OnePlus 7 Pro",
    img: "/assets/oneplus7-pro-front.jpg",
    price: 799,
    company: "OnePlus",
    info:
      "Display Perfectly Smooth Triple Camera A camera for every moment Twist/distortion Charge 30 Ready in 20 minutes Display See the smoothness. The 6.67 inch Fluid AMOLED display on the OnePlus 7 Pro is our most advanced screen ever. Experience (without any competition) smoothness and clearness with a 90 Hz refresh rate and QHD+ (ability to display or measure very small things). QHD+ resolution Experience a bright and sharp display with a 90 Hz refresh rate, designed to display your content with dramatic clearness.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "iPhone XS Max",
  img: "/assets/iphone-front.png",
  price: 1200,
  company: "Apple",
  info:
    "A Super Retina OLED display. Even faster Face ID. And a breakthrough dual-camera system. The iPhone XS is everything you love about iPhone. Taken to the extreme. Apple finally delivers an iPhone with a huge screen, and for movie-watching, game-playing fans the iPhone XS Max is an exciting new addition to the range. It certainly costs a lot, but if you can get past the price (which many won't be able to) the XS Max offers up a super, supersized experience.",
  inCart: false,
  count: 0,
  total: 0
};
